import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './routemenu.scss';
import dashboard from '../dashboard.png';
import invoice from '../invoice.png';
import po from '../po.png';
import delivery from '../delivery.png';
const RouteMenu = () => {
  const location = useLocation();
  const [selected, setSelected] = useState('dashboard');

  const menuItems = [
    { id: 'dashboard', icon: dashboard, label: 'Dashboard ', route: '/' },
    { id: 'quotation', icon: invoice, label: 'Quotation', route: '/quotations' },
    { id: 'purchase-order', icon: po, label: 'Purchase Order', route: '/purchase-order' },
    { id: 'delivery-schedule', icon: delivery, label: 'Delivery Schedule', route: '/delivery-schedule' },
  ];

  useEffect(() => {
    const currentRoute = menuItems.find((item) => item.route === location.pathname);
    if (currentRoute) {
      setSelected(currentRoute.id);
    }
  }, [location.pathname, menuItems]);

  return (
    <div className="sidebar">
      {menuItems.map((item) => (
        <Link
          key={item.id}
          to={item.route}
          className={`sidebar-item ${selected === item.id ? 'selected' : ''}`}
          onClick={() => setSelected(item.id)}
        >
          {/* <FontAwesomeIcon icon={item.icon} size="lg" /> */}
          <img src={item.icon}></img>
          <span>{item.label}</span>
        </Link>
      ))}
    </div>
  );
};

export default RouteMenu;